// import 'select2';
// $(document).ready(function(){
//   if ($(".is_collased").attr("value") == "true") {
//     $("#collapseExample").show();
//     $(".collapse-button").addClass('collapsed');
//   }
// })
// import './angle/modules/forms/select2';
import $ from 'jquery';
import 'select2';

$(function () {
  console.log('courier profile document loaded')
  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get('q');
  const searchInput = $('.search-couriers');

  if (searchQuery) {
    searchInput.val(decodeURIComponent(searchQuery));
  }
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  $(document).on("change", '.search-couriers', function (e) {

    let $this = $(this);
    let query = $this.val().trim();
    let currentPage = $this.data('page') || 1;

    // Define the function to be debounced
    function handleSearch() {
      if (query.length > 0) {
        let encodedQuery = encodeURIComponent(query);
        window.location.href = "/couriers?q=" + encodedQuery + "&page=" + currentPage;
      } else {
        window.location.href = "/couriers?page=" + currentPage;
      }
    }
    // Use debounce to limit the rate at which handleSearch is called
    debounce(handleSearch, 300)();
  });

  if ($(".courier-profile").length) {
    //onload populate staff fields
    console.log('select values', $(".select-company-staff"))
    

    $(".select-company-staff").on("change", function () {
      console.log('staff company changed')
      var staff_image = $(document).find('.company-staff-profile-image')
      var first_name = $(document).find('.contact-information').find('.firstname')
      var lastname = $(document).find('.contact-information').find('.lastname')
      var role = $(document).find('.contact-information').find('.role')
      var department = $(document).find('.contact-information').find('.department')
      var landline = $(document).find('.contact-information').find('.landline')
      var mobile = $(document).find('.contact-information').find('.mobile')
      var email = $(document).find('.contact-information').find('.email')
      var address1 = $(document).find('.contact-information').find('.address1')
      var address2 = $(document).find('.contact-information').find('.address2')
      $.ajax({
        type: "GET",
        url: "../api/staff/" + $(this).val() + "",
        success: function (result) {
          if (result.status === 200) {
            console.log('result data:', result)
            staff_image.attr("src", result.data.profile_image)
            first_name.text(result.data.first_name)
            lastname.text(result.data.last_name)
            if (result.data.role === 'courier_admin') {
              role.text("Admin")
            }
            else {
              role.text("Staff")
            }

            mobile.text(result.data.phone_number)
            email.text(result.data.email)
            address1.text(result.data.address1)
            address2.text(result.data.address2)
          }
        }
      });
    })
    if ($(".select-company-staff").val().length) {
      var staff_image = $(document).find('.company-staff-profile-image')
      var first_name = $(document).find('.contact-information').find('.firstname')
      var lastname = $(document).find('.contact-information').find('.lastname')
      var role = $(document).find('.contact-information').find('.role')
      var department = $(document).find('.contact-information').find('.department')
      var landline = $(document).find('.contact-information').find('.landline')
      var mobile = $(document).find('.contact-information').find('.mobile')
      var email = $(document).find('.contact-information').find('.email')
      var address1 = $(document).find('.contact-information').find('.address1')
      var address2 = $(document).find('.contact-information').find('.address2')
      $.ajax({
        type: "GET",
        url: "../api/staff/" + $(".select-company-staff").val() + "",
        success: function (result) {
          if (result.status === 200) {
            staff_image.attr("src", result.data.profile_image)
            first_name.text(result.data.first_name)
            lastname.text(result.data.last_name)
            if (result.data.role === 'courier_admin') {
              role.text("Admin")
            }
            else {
              role.text("Staff")
            }
            // department.text(result.data)
            // landline.text(result.data)
            mobile.text(result.data.phone_number)
            email.text(result.data.email)
            address1.text(result.data.address1)
            address2.text(result.data.address2)
          }
        }
      });
    }
    $(".select-company-staff").select2(
      {
        theme: 'bootstrap4',
        placeholder: "Select company staff",
        templateResult: formatState,
        templateSelection: formatSelection
      }
    );
  }
  function formatState(state) {
    if (!state.id) {
      return state.text;
    }
    var $state = $(
      '<span class="' + state.title + '" >' + state.text + '<em class="fa fas fa-plus"></em><em class="fa fas fa-minus"></em></span>'
    );
    return $state;
  };

  function formatSelection(state) {
    console.log('state data', state, !state.id)
    if (!state.id) {
      console.log('returning state text', state.text)
      return state.text;
    }
    console.log('not called')
    var $state = $("<span>" + state.text + "</span>");
    $state.find("span").remove();
    return $state;
  };
})
$(function () {
  function checkFileSize(file, maxSize) {
    var size = file.files[0].size;
    var mb = 0;
    var k = 1024;
    var m = 1000;
    var compare = k * m;
    mb = size / compare;

    return (mb > maxSize);
  }

  $(document).on("click", ".btn-invite", function () {
    var $popup = $("#inviteCourier");
    var courierId = $(this).attr("courier_id");
    console.log('invite button clicked', courierId)
    $("#courierIdPlaceholder").text(courierId);
    $popup.find(".email, .company-name").val("");
    $popup.find(".email").get(0).focus();
    $popup.find(".loading-div.whirl.no-overlay").addClass("hide");
    $popup.find(".buttons-row").removeClass("hide");
    $popup.find(".message, .error").html("");
    $popup.find(".message, .error, .btn-confirm").addClass("hide");
    $popup.find(".btn-send-invite, .btn-cancel").removeClass("hide");
  });
  $("#inviteAgent").on("click", ".btn-send-invite", function () {
    var $popup = $("#inviteAgent");
    if ($popup.find(".email").val() != "") {
      var $form = $popup.find(".admin-info");
      $popup.find(".loading-div.whirl.no-overlay").removeClass("hide");
      $popup.find(".buttons-row").addClass("hide");
      $popup.find(".message, .error").html("");

      var courierId = $("#courierIdPlaceholder").text();
      console.log('Initiate invite courier:', courierId);
      $.ajax({
        type: "POST",
        url: "/agents/send_invitation",
        data: { id: courierId },
        success: function (result) {
          if (result.status != 300) {
            $popup.find(".message").html(result.message);
            $popup.find(".message, .btn-confirm").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").addClass("hide");
          }
          else {
            $popup.find(".error").html(result.error);
            $popup.find(".error").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").removeClass("hide");
          }
          $popup.find(".buttons-row").removeClass("hide");
          $popup.find(".whirl.no-overlay").addClass("hide");
        }
      });
    }
  });
  $("#inviteCourier").on("click", ".btn-send-invite", function () {
    var $popup = $("#inviteCourier");
    if ($popup.find(".email").val() != "") {
      var $form = $popup.find(".admin-info");
      $popup.find(".loading-div.whirl.no-overlay").removeClass("hide");
      $popup.find(".buttons-row").addClass("hide");
      $popup.find(".message, .error").html("");
      $.ajax({
        type: "POST",
        url: "/couriers/send_invitation",
        data: new FormData($form[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {
          if (result.status != 300) {
            $popup.find(".message").html(result.message);
            $popup.find(".message, .btn-confirm").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").addClass("hide");
          }
          else {
            $popup.find(".error").html(result.error);
            $popup.find(".error").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").removeClass("hide");
          }
          $popup.find(".buttons-row").removeClass("hide");
          $popup.find(".whirl.no-overlay").addClass("hide");
        }
      });
    }
  });

  if ($(".new-courier").length) {
    $(".aside-container, .topnavbar-wrapper, .offsidebar").remove();
    $(".section-container").addClass("section-admin-register");

    $(document).on('submit', 'form', function () {
      $("button.loading-btn").click();
    });
  }

  if ($(".courier-profile").length) {
    console.log('courier profile loaded')
    var $userId = $(".courier-profile").attr("userId");
    var $courierContacts = $(".courier-content.contacts");
    var $companyDetails = $(".courier-content.company-details");
    var $staffDetails = $(".courier-content.staff-details");
    var $editStaffProfile = $("#editStaffProfile");
    var $editCompanyProfile = $("#editCompanyProfile");
    //enable select 2 for selecting staff

    $(document).on("change", ".upload-staff-profile", function () {
      console.log('initiate upload profile')
      if (checkFileSize(this, 5)) {
        $('#loadingModal').find(".loading-row").addClass("hide");
        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $('#loadingModal').find(".error").removeClass("hide").html("Image file must be less than 5mb");
        $("button.loading-btn").click();
        $(this).val("");
      }
      else if ($val != "") {
        var $this = $(this);
        var $val = $this.val();
        var $form = $this.parents("form");

        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row").addClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $("button.loading-btn").click();
        $.ajax({
          type: "PUT",
          url: "upload_image",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
            if (result.status == 200) {
              var $image = result.image;
              // if($this.attr("image_type") == "banner") {
              //   $(".seller-profile").find(".images-container .banner").attr("src", $image.url);
              //   $("#editImageBannerModal").find(".banner-image").attr("src", $image.url);
              // }
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              $staffDetails.find(".image-container .image").attr("src", $image.url);
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.error);
              console.log(result.error);
            }
            $this.val("");
          },
          error: function (result) {
          }
        });
      }
    })

    $courierContacts.on("click", ".image", function () {
      $courierContacts.find(".image").removeClass("focused");
      $(this).addClass("focused");
      $courierContacts.find(".contact-information").addClass("hide");
      $courierContacts.find(".contact-information[staff_id=" + $(this).attr("staff_id") + "]").removeClass("hide");
    });

    $staffDetails.on("change", ".upload-profile", function () {
      console.log('change profile initiated', $userId)
      if (checkFileSize(this, 5)) {
        $('#loadingModal').find(".loading-row").addClass("hide");
        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $('#loadingModal').find(".error").removeClass("hide").html("Image file must be less than 5mb");
        $("button.loading-btn").click();
        $(this).val("");
      }
      else if ($val != "") {
        var $this = $(this);
        var $val = $this.val();
        var $form = $this.parents("form");

        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row").addClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $("button.loading-btn").click();
        $.ajax({
          type: "PUT",
          url: "upload_image",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
            if (result.status == 200) {
              var $image = result.image;
              // if($this.attr("image_type") == "banner") {
              //   $(".seller-profile").find(".images-container .banner").attr("src", $image.url);
              //   $("#editImageBannerModal").find(".banner-image").attr("src", $image.url);
              // }
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              $staffDetails.find(".image-container .image").attr("src", $image.url);
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.error);
              console.log(result.error);
            }
            $this.val("");
          },
          error: function (result) {
          }
        });
      }
    });

    $staffDetails.on("click", ".edit", function () {
      $editStaffProfile.find(".loading-row").addClass("hide");
      $editStaffProfile.find(".main-buttons-row, .content-row").removeClass("hide");
      $editStaffProfile.find(".message-row, .message, .error, .confirm-button-row").removeClass("hide");
      $editStaffProfile.find(".message, .error").html("");
    });

    $editStaffProfile.on("click", ".btn-update", function () {
      var $staffInfo = $editStaffProfile.find(".staff-info");
      var $obj = {};
      var variables = [];

      $editStaffProfile.find(".loading-row").removeClass("hide");
      $editStaffProfile.find(".main-buttons-row, .content-row").addClass("hide");

      $staffInfo.find("input").each(function () {
        $obj[$(this).attr("name") + ""] = $(this).val();
        variables.push($(this).attr("name") + "");
      });

      $.ajax({
        type: "PUT",
        url: "/update",
        data: new FormData($staffInfo[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {

          $editStaffProfile.find(".main-buttons-row, .content-row").addClass("hide");
          $editStaffProfile.find(".content-row").removeClass("hide");
          $editStaffProfile.find(".loading-row").addClass("hide");
          if (result.status == 200) {
            $staffInfo.find("input").each(function () {
              var $this = $(this);
              $this.attr("default_value", $this.val());
              $(".courier-profile").find($this.attr("display")).html($this.val());
            });
            $editStaffProfile.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $editStaffProfile.find(".message-row .message").html(result.message);

            setInterval('location.reload()', 2000);
          }
          else {
            $editStaffProfile.find(".message-row, .error, .main-buttons-row").removeClass("hide")
            $editStaffProfile.find(".message-row .error").html(result.error);
          }
        },
        error: function (result) {
        }
      });
    });

    $editStaffProfile.on("click", ".btn-reset", function () {
      var $parent = $(this).parents(".modal-body");
      $parent.find("form").find("input").each(function () {
        var $this = $(this);
        $this.val($this.attr("default_value"));
      });
    });

    $companyDetails.on("click", ".edit", function () {
      $editCompanyProfile.find(".loading-row").addClass("hide");
      $editCompanyProfile.find(".main-buttons-row, .content-row").removeClass("hide");
      $editCompanyProfile.find(".message-row, .message, .error, .confirm-button-row").removeClass("hide");
      $editCompanyProfile.find(".message, .error").html("");
    });

    $editCompanyProfile.on("change", ".company-logo .upload-logo", function () {
      var $this = $(this);
      var $val = $this.val();
      if (checkFileSize(this, 5)) {
        $editCompanyProfile.find(".company-logo .error-message").removeClass("hide").html("Image file must be less than 5mb");
        $(this).val(null);
      }
      else {
        console.log("something")
        const [file] = $this[0].files;
        $editCompanyProfile.find(".logo-image-container p").addClass("hide");
        $editCompanyProfile.find(".logo-image-container .logo-image").attr("src", URL.createObjectURL(file)).removeClass("hide");
      }
    });

    $editCompanyProfile.on("click", ".btn-update", function () {
      var $companyInfo = $editCompanyProfile.find(".company-info");
      var $obj = {};
      var variables = [];

      $editCompanyProfile.find(".loading-row").removeClass("hide");
      $editCompanyProfile.find(".main-buttons-row, .content-row").addClass("hide");

      $companyInfo.find("input").each(function () {
        $obj[$(this).attr("name") + ""] = $(this).val();
        variables.push($(this).attr("name") + "");
      });

      $.ajax({
        type: "PUT",
        url: "/update",
        data: new FormData($companyInfo[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {

          $editCompanyProfile.find(".main-buttons-row, .content-row").addClass("hide");
          $editCompanyProfile.find(".content-row").removeClass("hide");
          $editCompanyProfile.find(".loading-row").addClass("hide");
          if (result.status == 200) {
            $companyInfo.find("input").each(function () {
              var $this = $(this);
              $this.attr("default_value", $this.val());
              $(".courier-profile").find($this.attr("display")).html($this.val());
            });
            $editCompanyProfile.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $editCompanyProfile.find(".message-row .message").html(result.message);
            setInterval('location.reload()', 2000);
          }
          else {
            $editCompanyProfile.find(".message-row, .error, .main-buttons-row").removeClass("hide")
            $editCompanyProfile.find(".message-row .error").html(result.error);
          }
        },
        error: function (result) {
        }
      });
    });

    $("#resetPassword").on("click", ".btn-reset", function () {
      var $this = $(this);
      var $popup = $(this).parents(".modal-body");
      var $sellerId = $(".seller-profile").attr("sellerId");
      var $form = $popup.find("form");
      $popup.find(".loading-row").removeClass("hide");
      $popup.find("button.close").css("visibility", "hidden");
      $popup.find(".error, .message").html("");
      $popup.find(".message-row, .message, .error").addClass("hide");
      $.ajax({
        type: "PUT",
        url: "/reset_password",
        data: new FormData($form[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {
          $popup.find("button.close").css("visibility", "visible");
          $popup.find(".loading-row").addClass("hide");
          if (result.status == 200) {
            $popup.find(".message-row, .message").removeClass("hide");
            $popup.find(".message-row .message").html(result.message);
          }
          else {
            $popup.find(".message-row, .error").removeClass("hide");
            $popup.find(".message-row .error").html(result.error);
          }
        },
        error: function (result) {
        }
      });
    });

    //end of profile length
  }

  if ($(".forgot_password").length) {
    $(".forgot_password").on("click", ".btn-submit", function () {
      if ($(".forgot_password").find(".user-email").val() != "") {
        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row").addClass("hide");
        $('#loadingModal').find(".message, .errir").addClass("hide").html("");
        $("button.loading-btn").click();

        $.ajax({
          type: "POST",
          url: "/couriers/send_reset_token",
          data: {
            email: $(".forgot_password").find(".user-email").val()
          },
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");

            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              $('#loadingModal').find(".btn-confirm").addClass("hide");
              $("#loadingModal").find(".btn-redirect").removeClass("hide");
            } else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.message);
            }
          },
          error: function (result) {
            result.errors();
          }
        });
      }
    });

    $("#loadingModal").on("click", ".btn-redirect", function () {
      window.location.href = "/sign_in"
    });
  }

  if ($(".couriers-reset-password").length) {
    $(".topnavbar-wrapper").css('display', 'none');
    $(".couriers-reset-password").on("click", ".btn-submit", function (e) {
      e.preventDefault();
      if ($(".forgot_password").find(".user-email").val() != "") {
        $("button.loading-btn").click();
        var $popup = $('#loadingModal');
        $popup.find(".error, .message").html("");
        var $form = $(".couriers-reset-password").find("form");

        $.ajax({
          type: "PUT",
          url: "/couriers/reset_courier_password",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            console.log("status " + result.status)
            $popup.find(".loading-row").addClass("hide");
            $popup.find(".message-row, .button-row").removeClass("hide");

            if (result.status == 200) {
              $popup.find(".message").removeClass("hide").html(result.message);
              $popup.find(".btn-confirm").addClass("hide");
              $popup.find(".btn-redirect").removeClass("hide");
            }
            else {
              $popup.find(".error").removeClass("hide").html(result.error);
            }
          },
          error: function (result) {
          }
        });
      }
    });
    $("#loadingModal").on("click", ".btn-redirect", function () {
      window.location.href = "/sign_in"
    });
  }
});